module.exports = __webpack_public_path__ + "media/fr_ca_s2_Chloe.496648d3.oga";